import React from "react";

export interface PlusButtonProps {
  onClick?: () => void;
  className?: string;
  type?: "button" | "submit" | "reset";
}
export const PlusButton = ({ onClick, type = "button", className = "" }: PlusButtonProps): JSX.Element => {
  return (
    <button
      onClick={onClick}
      type={type}
      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded border border-slate-200 bg-white p-1.5 shadow-sm hover:border-slate-300 dark:border-slate-700 dark:bg-slate-800 dark:hover:border-slate-600 ${className}`}
    >
      <svg className="text-primary-500 h-4 w-4 fill-current" viewBox="0 0 16 16">
        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1Z" />
      </svg>
    </button>
  );
};
